// Save login time
export const setLoginTime = () => {
  localStorage.setItem("login_time", Date.now());
};

// Check expiry (4 hours)
export const isTokenExpired = () => {
  const loginTime = localStorage.getItem("login_time");

  if (!loginTime) return true;

  const now = Date.now();
  const diff = now - parseInt(loginTime);

  const FOUR_HOURS = 4 * 60 * 60 * 1000;

  return diff > FOUR_HOURS;
};